import {Component, OnInit} from '@angular/core';
import {ModalController, NavParams} from "@ionic/angular";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";


export type PushNotificationButton = {
    title: string;
    type: string; // 'url' | 'close' | other types
    url?: string; // present if type is 'url'
}
export type PushNotification = {
    title: string;
    body: string;
    image?: string;
    buttons?: PushNotificationButton[];
}

@Component({
    selector: 'app-push-message-modal',
    templateUrl: './push-message.component.html',
    styleUrls: ['./push-message.component.scss'],
})
export class PushMessageComponentModal implements OnInit {

    public notification: PushNotification;


    constructor(
        private modalCtrl: ModalController,
        private navParams: NavParams,
        public myGcService: MyGreenCountry
    ) {
    }

    ngOnInit() {

        this.notification = this.navParams.data['notification'] ?? null;

    }

    close() {

        return this.modalCtrl.dismiss(null, 'cancel');

    }

    onButtonClick(btn: PushNotificationButton) {

        if(btn.type == "url") {

            if (btn.url) {
                this.myGcService.openUrl(btn.url);
            }

        }else {

            this.close();

        }

    }



}
